define.alias("shared/components/shared/carousel/index", "calendar/components/shared/carousel/index");